import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'

import { cn } from '../../lib/utils'

const sectionVariants = cva('relative scroll-mt-24', {
  variants: {
    variant: {
      hero: 'pt-10 md:pt-14',
      default: 'pt-16',
      compact: 'pt-10',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

type SectionProps = React.ComponentProps<'section'> & VariantProps<typeof sectionVariants>

function Section({ className, variant, ...props }: SectionProps) {
  return (
    <section
      data-slot="section"
      className={cn(sectionVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Section, sectionVariants, type SectionProps }
